import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from './SEO';
import { articlesMetadata } from '../data/articlesMetadata';
import '../styles/articles.css';

export const Articles: React.FC = () => {
  // Sort articles by date in descending order
  const sortedArticles = [...articlesMetadata].sort((a, b) => 
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <>
      <SEO 
        title="POE2 Guides & Articles"
        description="Latest Path of Exile 2 guides, build tutorials, and in-depth articles. Stay updated with game mechanics, class builds, and expert strategies."
        canonicalUrl="https://www.poe2skills-ai.com/articles"
      />
      <div className="articles-container">
        <h1>Latest Articles</h1>
        <div className="articles-grid">
          {sortedArticles.map((article) => (
            <div key={article.id} className="article-card">
              {article.imageUrl && (
                <div className="article-image">
                  <img src={article.imageUrl} alt={article.title} />
                </div>
              )}
              <div className="article-content">
                <h2>
                  <Link to={`/articles/${article.id}`}>{article.title}</Link>
                </h2>
                <p className="article-description">{article.description}</p>
                <div className="article-metadata">
                  <span className="article-date">{article.date}</span>
                  <span className="article-category">{article.category}</span>
                </div>
                <div className="article-tags">
                  {article.tags.map((tag, index) => (
                    <span key={index} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};